
export const MODALS = {
  saveUserModal: "SAVE_USER_MODAL",
};